
<!-- 
  Article inner content
-->

<template>
  <div class="container" id="contact-section">

    <div class="row text-center desktop">
      <h2 class="heading-light">GET IN TOUCH</h2>
<!--       <div class="contact-social-icon">

          <img class="social-icon-svg social-icon-svg-dark" :src="'static/img/common/'+ contact.email_icon_dark" type="image/svg+xml" />
          <img class="social-icon-svg social-icon-svg-light" :src="'static/img/common/'+ contact.email_icon_light" type="image/svg+xml" />
        
      </div> -->

      <a v-bind:href="contact.instagram_link">
        <span class="contact-social-icon"><img class="social-icon-svg" :src="'static/img/common/'+ contact.instagram_icon_dark" type="image/svg+xml" /></span>
        <span v-html="contact.instagram_text"></span>
      </a>

      <br/>

      <a v-bind:href="contact.email_link">
        <span class="contact-social-icon"><img class="social-icon-svg" :src="'static/img/common/'+ contact.email_icon_dark" type="image/svg+xml" /></span>
        <span v-html="contact.email_text"></span>
      </a>

      <br/>

      <a v-bind:href="contact.phone_link">
        <span class="contact-social-icon"><img class="social-icon-svg" :src="'static/img/common/'+ contact.phone_icon_dark" type="image/svg+xml" /></span>
        <span v-html="contact.phone_text"></span>
      </a>

      <!-- <a v-bind:href="contact.instagram_link" target="_blank">
        <div class="contact-social-icon contact-social-icon-insta">
            <img class="social-icon-svg social-icon-svg-dark" :src="'static/img/common/'+ contact.instagram_icon_dark" type="image/svg+xml" />
        </div>
        <span v-html="contact.instagram_text"></span>
      </a>
      <br/>
      <a v-bind:href="contact.phone_link" target="_blank">
        <div class="contact-social-icon contact-social-icon-insta">
          <img class="social-icon-svg social-icon-svg-dark" :src="'static/img/common/'+ contact.phone_icon_dark" type="image/svg+xml" />
        </div>
        <span v-html="contact.phone_text"></span>
      </a> -->
    </div>

    <div class="row text-center mobile">
      <h2 class="heading-light">GET IN TOUCH</h2>
      <div class="contact-social-icon">
        <a v-bind:href="contact.email_link">
          <img class="social-icon-svg social-icon-svg-dark" :src="'static/img/common/'+ contact.email_icon_dark" type="image/svg+xml" />
          <img class="social-icon-svg social-icon-svg-light" :src="'static/img/common/'+ contact.email_icon_light" type="image/svg+xml" />
        </a>
      </div>

      <div class="contact-social-icon contact-social-icon-insta">
        <a v-bind:href="contact.instagram_link" target="_blank">
          <img class="social-icon-svg social-icon-svg-dark" :src="'static/img/common/'+ contact.instagram_icon_dark" type="image/svg+xml" />
          <img class="social-icon-svg social-icon-svg-light" :src="'static/img/common/'+ contact.instagram_icon_light" type="image/svg+xml" />
        </a>
      </div>

      <div class="contact-social-icon contact-social-icon-insta">
        <a v-bind:href="contact.phone_link" target="_blank">
          <img class="social-icon-svg social-icon-svg-dark" :src="'static/img/common/'+ contact.phone_icon_dark" type="image/svg+xml" />
          <img class="social-icon-svg social-icon-svg-light" :src="'static/img/common/'+ contact.phone_icon_light" type="image/svg+xml" />
        </a>
      </div>
    </div>
  </div>
</template>

<style scoped="true">
  .contact-social-icon {
    display: inline-block;
    margin: 0 5px;
    height: 40px;
    width: 40px;
    position: relative;
    -webkit-transition: 0.2s ease-in-out;
    transition: 0.2s ease-in-out;
    background-color: #fff;
    cursor: pointer;
  }

  .desktop .contact-social-icon {
    height: auto;
    width: auto;
    margin: 12px 0;
  }

  .social-icon-svg {
    position: absolute;
    height: 100%;
    width: auto;
    padding: 0px;
    height: 22px;
    top:10px;
    left:9px;
  }
  .desktop .social-icon-svg {
    position: relative!important;
    height: 16px;
/*    margin-right: 10px;*/
    width: auto;
    padding: 0px;
    top:auto;
    left: auto;
    margin-top: -2px;
  /*  top:10px;
    left:9px;*/
  }
  .desktop a {
    text-decoration: none;
    font-size: 12px;
  }
  .desktop a:hover > span {
    color: #ec7d8d;
  }
  .contact-social-icon-insta .social-icon-svg {
    height: 20px;
    left:10px;
  }
  .social-icon-svg-dark {
    opacity: 1;
  }
  .social-icon-svg-light {
    opacity: 0;
  }
/*  .no-touch-device .contact-social-icon:hover {
    background-color: rgba(209,166,153,0.2);
  }*/
  .mobile .contact-social-icon:active {
    background-color: rgba(209,166,153,0.6);
  }
/*  .no-touch-device .contact-social-icon:hover > a .social-icon-svg-dark {
    opacity: 0!important;
  }
  .no-touch-device .contact-social-icon:hover >  a .social-icon-svg-light {
    opacity: 1;
  }*/

</style>

<script>
// import Vue from 'vue'
import {contact} from '../../content.json'
import LinkButton from '../components/LinkButton'

export default {
  data: function () {
    return {
      contact
    }
  },
  methods: {
  },
  created () {

  },
  destroyed () {

  },
  mounted: function () {
  },
  components: {
    LinkButton
  }
}
</script>



// WEBPACK FOOTER //
// ContactSection.vue?1d979cc9